// extracted by mini-css-extract-plugin
module.exports = {"social-links":"SocialLinks_social-links__lZXF1","row":"SocialLinks_row__vytj3","light":"SocialLinks_light__91AGU"};